import { IStateAutocomplete } from 'addresses/types';
import { formatDateForServer, objectKeysCamelToSnakeCase } from 'core/utils';
import { IAddProjectForm } from 'projects/types';

export const mapUpsertProjectForm = (data: IAddProjectForm) => {
  const { address, verticalMarket, validSince, validUntil, ...rest } = data;

  return objectKeysCamelToSnakeCase({
    project: {
      ...rest,
      address: {
        ...address,
        country: address?.country?.abbreviation,
        state: (address?.state as IStateAutocomplete)?.id || address?.state,
      },
      verticalMarketId: verticalMarket?.id,
      validSince: formatDateForServer(validSince),
      validUntil: formatDateForServer(validUntil),
    },
  });
};
